/*
    Přidání kategorie
*/
import React,{ Component,Fragment } from 'react';
import {Mutation,Query} from 'react-apollo';
import Loading from '../../../GlobalComponents/Loading';
import Error from '../../../GlobalComponents/Error';
import Modal from 'react-modal';
import { Editor } from '@tinymce/tinymce-react';
import {ADD_EDIT_CATEGORY,GET_CATEGORIES,GENERATE_CATEGORY_LANG} from '../Queries/index.js';
import SelectSubCategory from './SelectSubCategory';
import { withApollo } from 'react-apollo';
import Notification from '../../../Library/notification';
import Helper from '../../../Library/helper';
import CategoryLib from '../Library/category';
import settingsIcon from '../../../Public/Images/settings.svg';
import CategoryTranslateSettings from './CategoryTranslateSettings';
import ProgressBar from '../../../GlobalComponents/ProgressBar';


const INITIAL_STATE = {
    err:"",
    mainPhoto:"",
    addLoading:false,
    showTranslateSettings:false,
    translatedLangsCount:0,
    formData:{
        generateTranslations:{
            enabled:true,
            onlyForParams:[],
            onlyFor:""
        },
        active:1,
        categoryID:0,
        showName:1,
        photo:null,
        langs:[],
        selectedLang:'cz'
    },
    allLanguageMutations:[],
    allFilterCategories:[]
}

class AddEditCategory extends Component{

    constructor(props){
        super(props);
        this.state = INITIAL_STATE;
        this.addCategory     = this.addCategory.bind(this);
        
        this.categoryLib = new CategoryLib(this); 
    }

    componentDidMount(){
        this.categoryLib.getData();

        if(this.props.selectedCategoryID && this.props.selectedCategoryID != 0)
            this.categoryLib.SetFormData("generateTranslations",{...this.state.formData.generateTranslations,enabled:false});
    }

    addCategory(addCategory){

        const {
            langs,
            active,
            categoryID,
            showName,
            photo,
            generateTranslations
        } = this.state.formData;

        let l = [];
        for(const lang of langs){
            l.push({
                name: lang.name,
                lang:lang.lang
            });
        }

        addCategory({
            variables:{
                active:parseInt(active),
                categoryID,
                showName:parseInt(showName),
                photo,
                langs:l,
                generateTranslations
            }
        });
    }

    render(){

        var {
            err,
            mainPhoto,
            addLoading,
            showTranslateSettings,
            allLanguageMutations
        } = this.state;

        const {selectedCategoryID} = this.props;

        return(

            <Mutation 
                mutation={ADD_EDIT_CATEGORY}
                errorPolicy = "all"
                refetchQueries = {(data)=>{
                    return [{
                        query:GET_CATEGORIES,
                        variables: { lang:"cz" }
                    }]
                }}
                update = {async (cache, response) => {

                    var success = true;

                    console.log("jsem tu");
                    console.log(this.state.formData.generateTranslations.enabled);

                    if(this.state.formData.generateTranslations.enabled)
                    {
                        this.setState({translatedLangsCount:1,addLoading:true});

                        for(let val of allLanguageMutations)
                        {
                            if(val.suffix != "cz" && val.suffix != "us")
                            {
                                try
                                {
                                    await this.props.client.mutate({
                                        mutation:GENERATE_CATEGORY_LANG,
                                        variables:{
                                            lang: val.suffix,
                                            categoryID: response.data.addEditCategory.categoryID,
                                            isEdit: (selectedCategoryID && selectedCategoryID != 0 ? true : false),
                                            onlyForParams:this.state.formData.generateTranslations.onlyForParams
                                        }
                                    });

                                    this.setState({translatedLangsCount:this.state.translatedLangsCount + (val.suffix == "en" ? 2 : 1)});

                                }
                                catch(err)
                                {
                                    const helper = new Helper(); 
                                    this.setState({
                                        err:helper.getApolloErrorText(err)
                                    });
                                    success = false;
                                    break;
                                }
                            }
                        }

                        this.setState({addLoading:false});
                    }

                    if(success)
                    {
                        this.props.refetch();

                        let notify = new Notification();

                        if(selectedCategoryID && selectedCategoryID != 0) 
                            notify.setNotification(cache,'Úspěšně uloženo',true,false);
                        else 
                            notify.setNotification(cache,'Úspěšně přidáno',true,false);

                        this.props.openCloseModal(false);

                    }

                }}                
            >
            {
                (addEditCategory,{loading, error}) => {

                    const {
                        langs,
                        active,
                        showName,
                        selectedLang,
                        generateTranslations
                    } = this.state.formData;
                    const {allLanguageMutations} = this.state;
                    
                    if(error){
                        const helper = new Helper(); 
                        err = helper.getApolloErrorText(error);
                    }

                    return(
                        <Modal
                            className="Modal__Bootstrap modal-dialog modal-lg"
                            closeTimeoutMS={150}
                            isOpen={true}
                            onRequestClose={() => !loading && !addLoading && this.props.openCloseModal(false)}
                        >
                            <div className="modal-content">
                                <div className="modal-header d-flex align-items-center">
                                    <h4 className="modal-title">{(selectedCategoryID && selectedCategoryID != 0 ? "Úprava kategorie" : "Přidání kategorie")}</h4>
                                    {!loading && !addLoading ? 
                                        <>
                                            <div className="select-lang">

                                                <div className={"form-check generate-all-langs" + (!generateTranslations.enabled ? " bigger" : "")}>
                                                    <input 
                                                        className="form-check-input" 
                                                        type="checkbox" 
                                                        name="generateTranslations" 
                                                        id={"generateTranslations"} 
                                                        checked={generateTranslations.enabled} 
                                                        onChange={(e) => {
                                                            this.categoryLib.SetFormData("generateTranslations",{...generateTranslations,enabled:e.target.checked},() => {
                                                                this.categoryLib.SetFormData("selectedLang","cz");
                                                            });
                                                        }}
                                                    />
                                                    <label className="form-check-label" htmlFor={"generateTranslations"}>
                                                        Vygenerovat všechny překlady
                                                    </label>
                                                    
                                                </div>

                                                {generateTranslations.enabled && selectedCategoryID && selectedCategoryID != 0 ?
                                                    <img 
                                                        className="cursor-pointer"
                                                        style={{height:"25px",marginLeft:"10px"}} 
                                                        src={settingsIcon} 
                                                        onClick={() => this.setState({showTranslateSettings:!showTranslateSettings})}
                                                    />
                                                :null}
                                                
                                                {!generateTranslations.enabled ?
                                                    <select className="form-control" name="selectedLang" onChange={(e) => this.categoryLib.formHandle(e)}>
                                                        {allLanguageMutations && allLanguageMutations.map((item,index) => (
                                                            <option key={index} value={item.suffix}> {item.suffix} </option>
                                                        ))}
                                                    </select>
                                                :null}
                                            </div>
                                            <button type="button" className="close ml-3" onClick={() => this.props.openCloseModal(false)}>                                    
                                                <span aria-hidden="true">x</span>
                                                <span className="sr-only">Close</span>
                                            </button>
                                        </>
                                    :null}
                                    {showTranslateSettings ?
                                        <CategoryTranslateSettings 
                                            generateTranslations = {generateTranslations}
                                            parent = {this}
                                        />
                                    :null}
                                </div>
                                <div className="modal-body">

                                    {err ?
                                        <Error text={err} />
                                    :
                                        <Fragment>
                                            {!loading && !addLoading ?
                                                <>
                                                    <div className="form-group input-group">
                                                        <div className="custom-file">
                                                            
                                                            <input
                                                                type="file"
                                                                className="custom-file-input"
                                                                id="customFile"
                                                                name="photo"
                                                                required
                                                                multiple
                                                                onChange={(e) => this.categoryLib.openImage(e)}
                                                            />
                                                            <label className="custom-file-label" htmlFor="customFile">Vyberte fotku</label>
                                                        </div>
                                                    </div>

                                                    {mainPhoto &&
                                                        <div className="row">
                                                            <div className="col-12 col-sm-4 mb-4">
                                                                <img className = "maxwidth-100" src={mainPhoto} />
                                                            </div>
                                                            <div className="col-12 col-sm-8">
                                                                <div className="row">

                                                                    <div className="col-12 col-sm-4">
                                                                        <label className="input-label">Aktivní</label>
                                                                        <div className="form-group">
                                                                            <div className="form-check form-check-inline">
                                                                                <input className="form-check-input" type="radio" name="active" id="active1" value="1" checked={(active == 1 ?  true : false)} onChange={(e) => this.categoryLib.formHandle(e)} />
                                                                                <label className="form-check-label" htmlFor="active1">
                                                                                    Ano
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-check form-check-inline">
                                                                                <input className="form-check-input" type="radio" name="active" id="active2" value="0" checked={(active == 0 ?  true : false)} onChange={(e) => this.categoryLib.formHandle(e)} />
                                                                                <label className="form-check-label" htmlFor="active2">
                                                                                    Ne
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-12 col-sm-4">
                                                                        <label className="input-label">Ukázat název v portále</label>
                                                                        <div className="form-group">
                                                                            <div className="form-check form-check-inline">
                                                                                <input className="form-check-input" type="radio" name="showName" id="showName1" value="1" checked={(showName == 1 ?  true : false)} onChange={(e) => this.categoryLib.formHandle(e)} />
                                                                                <label className="form-check-label" htmlFor="showName1">
                                                                                    Ano
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-check form-check-inline">
                                                                                <input className="form-check-input" type="radio" name="showName" id="showName2" value="0" checked={(showName == 0 ?  true : false)} onChange={(e) => this.categoryLib.formHandle(e)} />
                                                                                <label className="form-check-label" htmlFor="showName2">
                                                                                    Ne
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                                            
                                                                    <div className="col-12">
                                                                        <label className="input-label">Název kategorie ({selectedLang})</label>
                                                                        <div className="form-group">
                                                                            <input className="form-control" type="text" name="name" value={this.categoryLib.getLangValue("name")} onChange={(e) => this.categoryLib.formLangHandle(e)} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </>
                                            :

                                                <div>
                                                    {generateTranslations.enabled ?
                                                        <div>
                                                            <p className = "text-center">Překládám...</p>
                                                            <ProgressBar
                                                                progressValue = {this.state.translatedLangsCount}
                                                                totalValue = {allLanguageMutations.length}
                                                            />
                                                        </div>
                                                    :
                                                        <Loading />  
                                                    }
                                                </div> 

                                            }  
                                        </Fragment>
                                    }
                                            
                                </div>
                                <div className="modal-footer"> 
                                    {!loading && !addLoading ? 
                                        <>
                                            <button type="button" className="btn btn-primary flex-fill" onClick={() => this.addCategory(addEditCategory)}>{(this.props.selectedCategoryID && this.props.selectedCategoryID != 0 ? "Upavit" : "Přidat")}</button>
                                            <button type="button" className="btn btn-danger" onClick={() => this.props.openCloseModal(false)}>Zavřít</button>
                                        </>
                                    :null}
                                </div>
                            </div>
                        </Modal>
                    );

                }
            }
            </Mutation>
        );
    }
}

export default withApollo(AddEditCategory);